export type Application = {
  partnerId: string
  configurationId: string
  logo: string
  displayName: string
}

// My Discounts hides any submission whose config is not listed here, so retired configs stay listed too.
export const applications: Record<string, Application[]> = {
  adobe: [
    {
      partnerId: 'partner_000000CxmmOOgXcpEMhqfpe9h5XRA',
      configurationId: 'hostedconfiguration_000000Ct5bOHoi04ENRR7EKfDb2cx',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/AdobeExpress.png'),
      displayName: 'Adobe Express'
    },
    {
      partnerId: 'partner_000000CxmmOOgXcpEMhqfpe9h5XRA',
      configurationId: 'hostedconfiguration_000000CxmmOOgXcpEMhqfpe9h5XRB',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/AdobeAcrobat.png'),
      displayName: 'Adobe Acrobat Pro'
    },
    {
      partnerId: 'partner_000000CxmmOOgXcpEMhqfpe9h5XRA',
      configurationId: 'hostedconfiguration_000000D4CSgA8ZhbGj7hHA8ezaSvI',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/AdobeAcrobat.png'),
      displayName: 'Adobe Acrobat Pro'
    }
  ],
  asana: [
    {
      partnerId: 'partner_000000CMkffPbLBHrqi7upWTjQ7Oq',
      configurationId: 'hostedconfiguration_000000CMkffPbLBHrqi7upWTjQ7Or',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Asana.png'),
      displayName: 'Asana'
    },
    {
      partnerId: 'partner_000000CMkffPbLBHrqi7upWTjQ7Oq',
      configurationId: 'hostedconfiguration_000000CMkffPbLBHrqi7upWTjQ7Zr',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Asana.png'),
      displayName: 'Asana'
    },
    {
      partnerId: 'partner_000000CMkffPbLBHrqi7upWTjQ7Oq',
      configurationId: 'hostedconfiguration_000000Cq3AlIGFxOpZKCQhiraOyJM',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Asana.png'),
      displayName: 'Asana'
    }
  ],
  atlassian: [
    {
      partnerId: 'partner_000000CBRzAHRM9WxOQCLvDOxYEIC',
      configurationId: 'hostedconfiguration_000000D9G9mKkREDKBeApKjIpJCgC',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Atlassian.png'),
      displayName: 'Atlassian'
    },
    {
      partnerId: 'partner_000000CBRzAHRM9WxOQCLvDOxYEIC',
      configurationId: 'hostedconfiguration_000000CK9XelTWGvt97OEDHsA0AY1',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Atlassian.png'),
      displayName: 'Atlassian'
    }
  ],
  auth0: [
    {
      partnerId: 'partner_000000CLYizw9WDDcSoVVzXIduCAq',
      configurationId: 'hostedconfiguration_000000Cp4wjpkOCwP9pYmcx08WqWm',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Auth0.png'),
      displayName: 'Auth0'
    },
    {
      partnerId: 'partner_000000CLYizw9WDDcSoVVzXIduCAq',
      configurationId: 'hostedconfiguration_000000CLYizw9WDDcSoVVzXIduCAr',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Auth0.png'),
      displayName: 'Auth0'
    }
  ],
  canva: [
    {
      partnerId: 'partner_000000CMTqjAZ1lf21cvt6GyJnUI4',
      configurationId: 'hostedconfiguration_000000CMTqjAZ1lf21cvt6GyJnUI6',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Canva.png'),
      displayName: 'Canva'
    },
    {
      partnerId: 'partner_000000CMTqjAZ1lf21cvt6GyJnUI4',
      configurationId: 'hostedconfiguration_000000CMTqjAZ1lf21cvt6GyJnUI5',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Canva.png'),
      displayName: 'Canva'
    }
  ],
  claude: [
    {
      partnerId: 'partner_000000DD5SkAcBzB5NPinaUhbQg2y',
      configurationId: 'hostedconfiguration_000000DOY5FzKZ8e8VPby0uQKpoWG',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Claude.png'),
      displayName: 'Claude'
    },
    {
      partnerId: 'partner_000000DD5SkAcBzB5NPinaUhbQg2y',
      configurationId: 'hostedconfiguration_000000DGLhLYdHYbnOXlJD81MbKnw',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Claude.png'),
      displayName: 'Claude'
    },
    {
      partnerId: 'partner_000000DD5SkAcBzB5NPinaUhbQg2y',
      configurationId: 'hostedconfiguration_000000DGLgwK3Nnx0eh0OEFycJL2e',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Claude.png'),
      displayName: 'Claude'
    },
    {
      partnerId: 'partner_000000DD5SkAcBzB5NPinaUhbQg2y',
      configurationId: 'hostedconfiguration_000000DGLgo1OL8JQ9PWzBCJ0MrBI',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Claude.png'),
      displayName: 'Claude'
    },
    {
      partnerId: 'partner_000000DD5SkAcBzB5NPinaUhbQg2y',
      configurationId: 'hostedconfiguration_000000DDDLsNXPtyPIHJJZfQDuXC4',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Claude.png'),
      displayName: 'Claude'
    },
    {
      partnerId: 'partner_000000DD5SkAcBzB5NPinaUhbQg2y',
      configurationId: 'hostedconfiguration_000000DD5SkAcBzB5NPinaUhbQg2z',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Claude.png'),
      displayName: 'Claude'
    }
  ],
  digitalOcean: [
    {
      partnerId: 'partner_000000CddprWIQQLavcgZkXPp1NUO',
      configurationId: 'hostedconfiguration_000000Ce5PTlEB8r77935QBjZdYI4',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/DigitalOcean.png'),
      displayName: 'DigitalOcean'
    }
  ],
  docusign: [
    {
      partnerId: 'partner_000000D23l5fFlEgLGOF1LhhRqKNk',
      configurationId: 'hostedconfiguration_000000D3RrbJGsD0oNwzZXI6GeqTh',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Docusign.png'),
      displayName: 'Docusign'
    },
    {
      partnerId: 'partner_000000D23l5fFlEgLGOF1LhhRqKNk',
      configurationId: 'hostedconfiguration_000000D5eLxKOWCONoWhEQf3cXwG0',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Docusign.png'),
      displayName: 'Docusign'
    },
    {
      partnerId: 'partner_000000D23l5fFlEgLGOF1LhhRqKNk',
      configurationId: 'hostedconfiguration_000000D3Rrfjl1tszaV6zIOBvYps6',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Docusign.png'),
      displayName: 'Docusign'
    }
  ],
  dropbox: [
    {
      partnerId: 'partner_000000Cp85VSokmOWpe8LhAapfLgO',
      configurationId: 'hostedconfiguration_000000Cp85VSokmOWpe8LhAapfLgP',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Dropbox.png'),
      displayName: 'Dropbox'
    }
  ],
  eventbrite: [
    {
      partnerId: 'partner_000000CmHVWilnsJZ9zPw4e8pkaJM',
      configurationId: 'hostedconfiguration_000000CmHVWilnsJZ9zPw4e8pkaJN',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Eventbrite.png'),
      displayName: 'Eventbrite'
    }
  ],
  fiverr: [
    {
      partnerId: 'partner_000000CxnxBNFwYX4eQ6oI9yHRR6e',
      configurationId: 'hostedconfiguration_000000CygVJN6whkvO0rNKvhaw0e0',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Fiverr.png'),
      displayName: 'Fiverr'
    },
    {
      partnerId: 'partner_000000CxnxBNFwYX4eQ6oI9yHRR6e',
      configurationId: 'hostedconfiguration_000000D5gsJZE9RiousPCskRWJla4',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Fiverr.png'),
      displayName: 'Fiverr'
    },
    {
      partnerId: 'partner_000000CxnxBNFwYX4eQ6oI9yHRR6e',
      configurationId: 'hostedconfiguration_000000CygVJN6whkvO0rNKvhaw0e1',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Fiverr.png'),
      displayName: 'Fiverr'
    },
    {
      partnerId: 'partner_000000CxnxBNFwYX4eQ6oI9yHRR6e',
      configurationId: 'hostedconfiguration_000000D3PK9zw8KAHkHyfAaLQsE64',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Fiverr.png'),
      displayName: 'Fiverr'
    }
  ],
  google: [
    {
      partnerId: 'partner_000000CKEn2WDB5hIbtfLjLCGZ6a8',
      configurationId: 'hostedconfiguration_000000CKEn2WDB5hIbtfLjLCGZ6a9',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Google.png'),
      displayName: 'Google'
    }
  ],
  hootsuite: [
    {
      partnerId: 'partner_000000CjaJGNpAvupsC4sHbLztaHQ',
      configurationId: 'hostedconfiguration_000000CjaJGNpAvupsC4sHbLztaHR',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Hootsuite.png'),
      displayName: 'Hootsuite'
    },
    {
      partnerId: 'partner_000000CjaJGNpAvupsC4sHbLztaHQ',
      configurationId: 'hostedconfiguration_000000CkYSbkdJabTBWmqdWIAgxQu',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Hootsuite.png'),
      displayName: 'Hootsuite'
    },
    {
      partnerId: 'partner_000000CjaJGNpAvupsC4sHbLztaHQ',
      configurationId: 'hostedconfiguration_000000D35QK4yGqSWcx2uUpXkP7oH',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Hootsuite.png'),
      displayName: 'Hootsuite'
    }
  ],
  linkedin: [
    {
      partnerId: 'partner_000000CXzPxxp1Gr1zH6HjmtNRu7s',
      configurationId: 'hostedconfiguration_000000CiNZpZdNN4VZpsUr6vnhBPk',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Linkedin.png'),
      displayName: 'LinkedIn'
    },
    {
      partnerId: 'partner_000000CXzPxxp1Gr1zH6HjmtNRu7s',
      configurationId: 'hostedconfiguration_000000ChZsuirSmB8w49WVvCCvzSC',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Linkedin.png'),
      displayName: 'LinkedIn'
    },
    {
      partnerId: 'partner_000000CXzPxxp1Gr1zH6HjmtNRu7s',
      configurationId: 'hostedconfiguration_000000D2JgYdYOStDGjHjHiAR5Cjq',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Linkedin.png'),
      displayName: 'LinkedIn'
    },
    {
      partnerId: 'partner_000000CXzPxxp1Gr1zH6HjmtNRu7s',
      configurationId: 'hostedconfiguration_000000CYLfgeUMNvaiToHEDg1KCYa',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Linkedin.png'),
      displayName: 'LinkedIn'
    },
    {
      partnerId: 'partner_000000CXzPxxp1Gr1zH6HjmtNRu7s',
      configurationId: 'hostedconfiguration_000000CXzPxxp1Gr1zH6HjmtNRu7t',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Linkedin.png'),
      displayName: 'LinkedIn'
    }
  ],
  lovable: [
    {
      partnerId: 'partner_000000DHjjxTfrnbxyVKgB5hPwCNU',
      configurationId: 'hostedconfiguration_000000DKNwpTa7akWOT6tNJ0Kfnrk',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Lovable.png'),
      displayName: 'Lovable'
    },
    {
      partnerId: 'partner_000000DHjjxTfrnbxyVKgB5hPwCNU',
      configurationId: 'hostedconfiguration_000000DHjjxTfrnbxyVKgB5hPwCNV',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Lovable.png'),
      displayName: 'Lovable'
    }
  ],
  microsoft: [
    {
      partnerId: 'partner_000000CjsIujTyTOUojcpDuaI5Su8',
      configurationId: 'hostedconfiguration_000000D1Z3GeqFqDWyG03Pu5vV7Ue',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Microsoft.png'),
      displayName: 'Microsoft'
    },
    {
      partnerId: 'partner_000000CjsIujTyTOUojcpDuaI5Su8',
      configurationId: 'hostedconfiguration_000000D1POc0fZdppZDpaHdMC13yq',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Microsoft.png'),
      displayName: 'Microsoft'
    }
  ],
  mondayCom: [
    {
      partnerId: 'partner_000000CJrvH858NhS0dQDWWNI6nTc',
      configurationId: 'hostedconfiguration_000000CK9XelTWGvt97OEDHsA0AYB',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/MondayCom.png'),
      displayName: 'monday.com'
    },
    {
      partnerId: 'partner_000000CJrvH858NhS0dQDWWNI6nTc',
      configurationId: 'hostedconfiguration_000000CK9XelTWGvt97OEDHsA0AYC',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/MondayCom.png'),
      displayName: 'monday.com'
    }
  ],
  newRelic: [
    {
      partnerId: 'partner_000000CddpqPft0837z9ioGOPINdo',
      configurationId: 'hostedconfiguration_000000Cdgy7H4anplpraLP3xYfbRg',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/NewRelic.png'),
      displayName: 'New Relic'
    }
  ],
  openAi: [
    {
      partnerId: 'partner_000000CkrkkKUg4D2mULQt9FsbYUS',
      configurationId: 'hostedconfiguration_000000CkrkkKUg4D2mULQt9FsbYUT',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Openai.png'),
      displayName: 'OpenAI'
    }
  ],
  sage: [
    {
      partnerId: 'partner_000000CKaPDCaCUGMcKk1B38w5AXY',
      configurationId: 'hostedconfiguration_000000CKaPDCaCUGMcKk1B38w5AXZ',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Sage.png'),
      displayName: 'Sage'
    }
  ],
  twilio: [
    {
      partnerId: 'partner_000000ChDQI2W3Zpa7RJ2DQnDWolc',
      configurationId: 'hostedconfiguration_000000ChDQI2W3Zpa7RJ2DQnDWold',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Twilio.png'),
      displayName: 'Twilio'
    }
  ],
  workvivo: [
    {
      partnerId: 'partner_000000D1rRF1RBsM2JwVGoERB5aS0',
      configurationId: 'hostedconfiguration_000000D2A4kBw3lugkjSF0d32DERc',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Workvivo.png'),
      displayName: 'Workvivo'
    }
  ],
  zoom: [
    {
      partnerId: 'partner_000000D2wBxPr8gVF485ywN1x51WK',
      configurationId: 'hostedconfiguration_000000D3RrzNoWCzM6UZKULiUpuTJ',
      logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Zoom.webp'),
      displayName: 'Zoom'
    }
  ]
}
